/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React, { MouseEventHandler } from 'react'
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    greyButton: {
        margin: '0 0 5px 0',
        textTransform: 'capitalize',
        borderRadius: '5px',
        fontSize: '11px',
    }
}));

interface GreyButtonProps {
    buttonLabel: string,
    onClick: MouseEventHandler,
    className?: string,
    disabled?: boolean,
    dataTestId?: string;
}

function GreyButton(props: GreyButtonProps) {
    const classes = useStyles();
    const {className, disabled, buttonLabel, dataTestId, onClick} = props;

    return (
        <Button
            data-testid={dataTestId}
            variant="contained"
            disableElevation
            classes={{root: classes.greyButton}}
            className={className}
            onClick={onClick}
            disabled={disabled}
        >
            {buttonLabel}
        </Button>
    )
}

export default GreyButton;
